import { Reducer } from 'redux';
import { TomadoresTransportadoraState, TomadoresTransportadoraTypes } from './types';

const INITIAL_STATE: TomadoresTransportadoraState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<TomadoresTransportadoraState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TomadoresTransportadoraTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TomadoresTransportadoraTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case TomadoresTransportadoraTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case TomadoresTransportadoraTypes.CLEAN_MOVIENTRADA:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
